import React from 'react';

import {labels} from '../../../../../util/utils';

import {defineCustomAttributesIcon} from '../../../../../util/svgIcons';

import DCAForm from './DCAForm';
import StyledDropdown from '../StyledDropdown';
import ToolbarButton from '../ToolbarButton';

const DefineCustomAttribute = () => {
	const renderTrigger = () => {
		const props = {
			svg: defineCustomAttributesIcon,
			label: labels.toolbarDefineAttributes
		};

		return <ToolbarButton {...props} />;
	};

	const props = {
		placement: 'bottom-right',
		trigger: renderTrigger(),
		reversed: true,
		topfix: true
	};

	return (
		<StyledDropdown {...props}>
			<DCAForm />
		</StyledDropdown>
	);
};

export default DefineCustomAttribute;
